import { Injectable } from '@angular/core';
import { ImageCarousel } from '@core/models';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class Modal {
  /** Subject que permite abrir la modal de carrusel de imagen completa */
  private readonly carouselImage$ = new Subject<ImageCarousel>();

  /**
   * Función que permite abrir la modal de carrusel de imagen completa
   * @param data Objeto con la información de la imagen del carrusel
   */
  onCarouselImage(data: ImageCarousel): void {
    this.carouselImage$.next(data);
  }

  /**
   * Función que obtiene un observable que permite saber si se debe abrir la modal
   * de carrusel de imagen completa
   * @returns Observable con la información de la imagen del carrusel
   */
  getCarouselImage$(): Observable<ImageCarousel> {
    return this.carouselImage$.asObservable();
  }
}
